import React from 'react';
import { captureException } from '../utils/sentry';

export const SentryTest: React.FC = () => {
  const testError = () => {
    try {
      // Intentionally throw an error
      throw new Error('Test error for Sentry in Haven AIstaging environment');
    } catch (error) {
      captureException(error, {
        environment: import.meta.env.MODE,
        testCase: 'manual-test',
      });
    }
  };

  const testUnhandledError = () => {
    // This will trigger the error boundary
    throw new Error(
      'Unhandled test error for Sentry in Haven AI staging environment'
    );
  };

  if (import.meta.env.MODE !== 'staging') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '20px',
        background: '#f0f0f0',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1000,
      }}
    >
      <h3>Sentry Test Panel</h3>
      <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
        <button
          onClick={testError}
          style={{
            padding: '8px 16px',
            background: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Test Handled Error
        </button>
        <button
          onClick={testUnhandledError}
          style={{
            padding: '8px 16px',
            background: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Test Unhandled Error
        </button>
      </div>
    </div>
  );
};
